/**
 * Result of barcode validation
 */
export interface BarcodeValidationResult {
  /**
   * Whether a valid barcode was found and successfully read
   */
  isValid: boolean;

  /**
   * The barcode format that was detected (e.g., 'PDF_417', 'QR_CODE')
   */
  barcodeFormat?: string;

  /**
   * Raw data extracted from the barcode
   */
  rawData?: string;

  /**
   * Error information if validation failed
   */
  error?: BarcodeValidationError;
}

/**
 * Error details when barcode validation fails
 */
export interface BarcodeValidationError {
  /**
   * Error code for programmatic handling
   */
  code: 'NO_BARCODE_FOUND' | 'INVALID_FORMAT' | 'SCAN_ERROR' | 'INVALID_IMAGE';

  /**
   * User-friendly error message
   */
  message: string;

  /**
   * Technical details for debugging
   */
  details?: string;
}

/**
 * Current status of barcode validation process
 */
export enum BarcodeValidationStatus {
  /**
   * No validation has started yet
   */
  IDLE = 'idle',

  /**
   * Currently scanning the image for barcodes
   */
  SCANNING = 'scanning',

  /**
   * Barcode found and validated successfully
   */
  SUCCESS = 'success',

  /**
   * Validation failed - no barcode found or error occurred
   */
  FAILED = 'failed',
}

/**
 * Type of document being validated
 */
export type DocumentType = 'id' | 'passport';
